import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class VideoService {
  constructor(private sanitization: DomSanitizer) {}

  getVideoEmbededUrl(data: any) {
    const vParam = this.getUrlParameterByName('v', data['video_url']);
    //only youtube has ?v= param in url
    if (vParam) {
      return this.getSafeUrlResource('https://www.youtube.com/embed/' + vParam);
    } else {
      return this.getSafeUrlResource(
        'https://player.vimeo.com/video/' + this.parseVimeoUrl(data['video_url']),
      );
    }
  }

  getSafeUrlResource(url: string): SafeUrl {
    return this.sanitization.bypassSecurityTrustResourceUrl(url);
  }

  getSafeUrl(url: string): SafeUrl {
    return this.sanitization.bypassSecurityTrustUrl(url);
  }

  initMediaDetailsVideoEmbededUrls(mediaDetails: any[]) {
    if (mediaDetails) {
      mediaDetails.map((mediaItem) => {
        if (mediaItem.media_type == 'external-video') {
          mediaItem.embededUrl = this.getVideoEmbededUrl(mediaItem);
        }
      });
    }
  }

  initMediaDetailsVideoResources(mediaDetails: any[]) {
    if (mediaDetails) {
      mediaDetails.map((mediaItem) => {
        if (mediaItem.media_type == 'external-video') {
          mediaItem.resource = this.getVideoResourse(mediaItem);
        }
      });
    }
  }

  getVideoResourse(data: any) {
    const vParam = this.getUrlParameterByName('v', data['video_url']);
    //only youtube has ?v= param in url
    if (vParam) {
      return 'youtube';
    } else {
      return 'vimeo';
    }
  }

  parseVimeoUrl(url: string) {
    const match = /vimeo.*\/(\d+)/i.exec(url);

    // If the match isn't null (i.e. it matched)
    if (match) {
      // The grouped/matched digits from the regex
      return match[1];
    } else {
      return false;
    }
  }

  getUrlParameterByName(name: string, url: string) {
    if (!url) return false;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
